export default {
  en: {
    hideMessage: 'Hide message text',
    showMessage: 'Show message text',
    listen: 'Listen',
    translate: 'Translate',
    hint: 'Hint: how to respond',
    hintLabel: 'You could say',
    recognizingVoice: 'Recognizing voice…',
    correct: 'Correct!',
    checking: 'Checking',
    explain: 'Explain',
    improve: 'Improve',
    edit: 'Edit text',
    editTitle: 'Edit text',
    editSave: 'Save',
    editHint: 'The tutor will reply again.',
  },
  ru: {
    hideMessage: 'Скрыть текст реплики',
    showMessage: 'Показать текст реплики',
    listen: 'Озвучить',
    translate: 'Перевести',
    hint: 'Подсказка: что ответить',
    hintLabel: 'Можно ответить так',
    recognizingVoice: 'Распознаю голос…',
    correct: 'Верно!',
    checking: 'Проверяю',
    explain: 'Объяснить',
    improve: 'Улучшить',
    edit: 'Исправить текст',
    editTitle: 'Исправить текст',
    editSave: 'Сохранить',
    editHint: 'Тьютор ответит заново.',
  },
  de: {
    hideMessage: 'Nachrichtentext ausblenden',
    showMessage: 'Nachrichtentext einblenden',
    listen: 'Anhören',
    translate: 'Übersetzen',
    hint: 'Tipp: Wie du antworten kannst',
    hintLabel: 'Du könntest sagen',
    recognizingVoice: 'Sprache wird erkannt…',
    correct: 'Richtig!',
    checking: 'Wird geprüft',
    explain: 'Erklären',
    improve: 'Verbessern',
    edit: 'Text korrigieren',
    editTitle: 'Text korrigieren',
    editSave: 'Speichern',
    editHint: 'Der Tutor antwortet neu.',
  },
  pt: {
    hideMessage: 'Ocultar texto da mensagem',
    showMessage: 'Mostrar texto da mensagem',
    listen: 'Ouvir',
    translate: 'Traduzir',
    hint: 'Dica: como responder',
    hintLabel: 'Você pode dizer',
    recognizingVoice: 'Reconhecendo a voz…',
    correct: 'Correto!',
    checking: 'Verificando',
    explain: 'Explicar',
    improve: 'Melhorar',
    edit: 'Corrigir texto',
    editTitle: 'Corrigir texto',
    editSave: 'Salvar',
    editHint: 'O tutor vai responder de novo.',
  },
  fr: {
    hideMessage: 'Masquer le texte du message',
    showMessage: 'Afficher le texte du message',
    listen: 'Écouter',
    translate: 'Traduire',
    hint: 'Astuce : comment répondre',
    hintLabel: 'Tu pourrais dire',
    recognizingVoice: 'Reconnaissance vocale…',
    correct: 'Correct !',
    checking: 'Vérification',
    explain: 'Expliquer',
    improve: 'Améliorer',
    edit: 'Corriger le texte',
    editTitle: 'Corriger le texte',
    editSave: 'Enregistrer',
    editHint: 'Le tuteur répondra de nouveau.',
  },
  es: {
    hideMessage: 'Ocultar el texto del mensaje',
    showMessage: 'Mostrar el texto del mensaje',
    listen: 'Escuchar',
    translate: 'Traducir',
    hint: 'Pista: cómo responder',
    hintLabel: 'Podrías decir',
    recognizingVoice: 'Reconociendo la voz…',
    correct: '¡Correcto!',
    checking: 'Revisando',
    explain: 'Explicar',
    improve: 'Mejorar',
    edit: 'Corregir texto',
    editTitle: 'Corregir texto',
    editSave: 'Guardar',
    editHint: 'El tutor responderá de nuevo.',
  },
};
